<template>
  <div class="aside-page">
    <aside class="aside-menu-page">
      <ul class="aside-menu-ul">
        <template v-for="(item, index) in ASIDE_MENU" :key="index">
          <li
            v-show="!item.__AUTH_ARG || isAllowAccess(item.__AUTH_ARG)"
            :class="{ active: props.currentPath.path.includes(item.url) }"
            @click="onRootSelect(item)"
          >
            <img
              v-if="props.currentPath.path.includes(item.url)"
              :src="item.checkIcon"
              alt=""
            />
            <img v-else :src="item.icon" alt="" />
            <el-badge
              :value="store.state.notify.unread"
              :max="99"
              v-if="item.url == '/information'"
            >
              {{ item.label }}
            </el-badge>
            <text v-else>{{ item.label }} </text>
          </li>
        </template>
      </ul>

      <transition name="el-fade-in-linear">
        <ul class="aside-menu-ul" v-if="childrenData.length > 0">
          <template v-for="(sub, sIndex) in childrenData" :key="sIndex">
            <li
              :class="{
                active:
                  props.currentPath.path.includes(sub.url) ||
                  ($route.query.path && $route.query.path.includes(sub.url))
              }"
              @click="onRouterPage(sub.url)"
              v-if="sub.__AUTH_ARG ? isAllowAccess(sub.__AUTH_ARG) : true"
            >
              {{ sub.label }}
            </li>
          </template>
        </ul>
      </transition>
    </aside>
  </div>
</template>
<script setup>
import lodash from "lodash";
import emitter from "tiny-emitter/instance";
import { isUrlWithParam } from "@/utils";
import { identifyInviteGroup, myApp } from "@/http/api/learning";
import { computed, getCurrentInstance, ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
const { proxy } = getCurrentInstance();
const router = useRouter();
const store = useStore();
const props = defineProps({
  currentPath: Object
});

const onRouterPage = (url) => router.push(url);

const onRootSelect = ({ url }) => {
  onRouterPage(url);
};

const currentCompany = computed(() => {
  return store.getters["auth/currentCompany"];
});

const isAllowAccess = computed(() => {
  return store.getters["auth/isAllowAccess"];
});

const ASIDE_MENU = computed(() => {
  let menu = lodash.cloneDeep(proxy.$constant.ASIDE_MENU);
  if (store.state.auth.userData.isSuperMan) {
    menu.splice(4, 1);
  }
  if(store.getters['auth/currentCompany'].companyId === "-1"){
    menu.splice(2, 1);
  }
  return menu;
});
const childrenData = computed(() => {
  let nowChildren = ASIDE_MENU.value.filter((menu) =>
    props.currentPath.path.includes(menu.url)
  );
  if (nowChildren.length > 0) {
    const { children } = ASIDE_MENU.value.filter((menu) =>
      props.currentPath.path.includes(menu.url)
    )[0];
    return children || [];
  } else {
    return [];
  }
});

onMounted(async () => {});
</script>
<style lang="scss" scoped>
.aside-page {
  position: relative;
}
.aside-menu-page {
  .text {
    margin: 20px 20px 0 20px;
    color: #adb5bd;
    font-weight: bold;
    font-size: 16px;
    text-align: left;
  }
  .aside-menu-ul {
    img {
      height: 25px;
      width: 25px;
      margin-right: 10px;
    }
    background-image: linear-gradient(0deg, #ffffff 0%, #ffffff 100%),
      linear-gradient(#ffffff, #ffffff);
    background-blend-mode: normal, normal;
    // box-shadow: 0px 0px 10px 0px rgba(44, 44, 44, 0.1),
    //   0px 0px 20px 0px rgba(44, 44, 44, 0.2);
    // border-radius: 8px;
    // border: solid 1px #3874f4;
    padding: 20px 0;
    & > li {
      font-size: 16px;
      padding: 10px 10px;
      margin: 0 20px 10px 20px;
      color: #8a92a6;
      user-select: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      i {
        font-size: 30px;
        margin-right: 10px;
      }
      & ~ li {
        margin-top: 5px;
      }
      &.active {
        border-radius: 4px;
        background: #ff6a00;
        box-shadow: 0px 2px 4px 0px #8a92a64c;
        color: #ffffff;
        font-weight: bold;
        background: $bg-color-orange;
      }
    }
    & ~ .aside-menu-ul {
      margin-top: 15px;
    }
  }
}
.el-badge {
  width: 100%;
  ::v-deep(.el-badge__content) {
    height: 12px;
    line-height: 12px;
    padding: 0px 4px;
    top: 11px;
    right: 25px;
    background: red;
  }
}
</style>
